import React from 'react';

import CtaWidget from '../../../../CtaWidget';
import { ModalNavCategory } from './MobileNavCategory';

import { MobileNavProps } from '../index';

interface Props extends MobileNavProps {
  isMenuOpen: boolean;
  toggleModal: () => void;
}

export function MobileModal({ navItems, modalMobileCta }: Props) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const categoryExpanded = navItems?.find(
    (item: any) => item.fields.isExpanded === true
  ) as any;
  const [titleExpanded, setTitleExpanded] = React.useState<string | undefined>(
    categoryExpanded?.fields?.name
  );

  return (
    <div 
      className="flex relative inset-0 items-center justify-center z-[1000] p-0 w-screen h-screen top-0 left-0 bg-white"
      aria-label="Navigation menu" 
      aria-modal="true"
    >
      <div className="flex flex-col w-full h-full outline-0">
        <div className="py-5 flex-1 overflow-y-scroll" data-testid="mobile-modal">
          {navItems &&
            navItems.map(({ fields }: any, idx: number) => (
              <ModalNavCategory
                {...fields}
                setTitleExpanded={setTitleExpanded}
                titleExpanded={titleExpanded}
                key={idx}
              />
            ))}
        </div>

        {modalMobileCta && (
          <div className="w-full px-6 py-8 bg-[#F2F5F5] flex flex-col items-center justify-center fixed bottom-0 left-0 right-0">
            <CtaWidget
              {...modalMobileCta?.fields}
              id="mobile-modal-nav-cta"
              sysId={modalMobileCta?.sys?.contentType?.sys?.id}
              module="Navigation"
              errorPosition="top"
            />
          </div>
        )}
      </div>
    </div>
  );
}
